var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3, _react_refresh_temp_4;
_react_refresh_temp_3 = $RefreshSig$();
_react_refresh_temp_4 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, memo, useContext, useMemo, } from 'react';
const initialFormEditContextValue = { isEdit: false };
const FormEditContext = createContext(initialFormEditContextValue);
export const useFormEditContext = () => {
    _react_refresh_temp_3();
    return useContext(FormEditContext);
};
_react_refresh_temp_3(useFormEditContext, "gDsCjeeItUuvgOWf1v4qoK9RF6k=");
export const FormEditProvider = memo(_react_refresh_temp_1 = _react_refresh_temp_4(({ children, isEdit }) => {
    _react_refresh_temp_4();
    return (_jsx(FormEditContext.Provider, { value: useMemo(() => ({ isEdit }), [isEdit]), children: children }));
}, "nwk+m61qLgjDVUp4IGV/072DDN4="));
$RefreshReg$(_react_refresh_temp_1, "FormEditProvider$memo");
_react_refresh_temp_2 = FormEditProvider;
$RefreshReg$(_react_refresh_temp_2, "FormEditProvider");
FormEditProvider.displayName = 'FormEditProvider';
